'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from 'contexts/InAppProvider';
import { PromotionPage } from 'app/(appHeader)/promotions/2025-balance-game-ritto/PromotionPage';
import { configure } from 'utils/configure';

const metadata = {
  title: '리토의 밸런스 게임! | 디리토',
  openGraph: {
    title: '리토의 밸런스 게임!',
    description:
      '둘 중에 하나만 골라!\n👉선택하고 댓글 남기면 최대 11,000P\n\n#리토의밸런스게임 #디리토 #웹소설밸런스게임',
    url: 'https://www.diritto.co.kr/promotions/2025-balance-game-ritto',
    siteName: '디리토',
    locale: 'ko_KR',
    type: 'website',
    images: [
      {
        url: `${configure.staticPrefix}/images/og/balance-ritto.png?v=1`,
        width: 400,
        height: 209,
      },
    ],
  },
};

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  return (
    <>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.openGraph.description} />
      <meta property="og:title" content={metadata.openGraph.title} key="title" />
      <meta property="og:description" content={metadata.openGraph.description} key="description" />
      <meta property="og:url" content={metadata.openGraph.url} key="url" />
      <meta property="og:site_name" content={metadata.openGraph.siteName} key="site_name" />
      <meta property="og:locale" content={metadata.openGraph.locale} key="locale" />
      <meta property="og:type" content={metadata.openGraph.type} key="type" />
      <meta property="og:image" content={metadata.openGraph.images[0].url} key="image" />
      <meta property="og:image:height" content={String(metadata.openGraph.images[0].height)} key="image:height" />
      <meta property="og:image:width" content={String(metadata.openGraph.images[0].width)} key="image:width" />
      <PromotionPage isApp={isApp} />
    </>
  );
}
